import { render } from "./AllPricePrediction.vue?vue&type=template&id=3fd162ce&scoped=true"
import script from "./AllPricePrediction.vue?vue&type=script&lang=js"
export * from "./AllPricePrediction.vue?vue&type=script&lang=js"

import "./AllPricePrediction.vue?vue&type=style&index=0&id=3fd162ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd162ce"]])

export default __exports__